(function () {
  'use strict';

  function getPickerOptionValueId(position) {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return null;

    const group = variantSelects.querySelectorAll('fieldset, .product-form__input--dropdown')[position - 1];
    if (!group) return null;

    if (group.tagName === 'FIELDSET') {
      return group.querySelector('input[type="radio"]:checked')?.dataset.optionValueId ?? null;
    }

    return group.querySelector('select')?.selectedOptions[0]?.dataset.optionValueId ?? null;
  }

  function activateSizeGuide(guide, optionValueId) {
    if (!optionValueId) return;

    guide.querySelectorAll('input[type="radio"][data-option-value-id]').forEach((radio) => {
      radio.checked = radio.dataset.optionValueId === optionValueId;
    });

    guide.querySelectorAll('[data-option-value-id]').forEach((element) => {
      if (element.matches('input[type="radio"]')) return;
      element.toggleAttribute('hidden', element.dataset.optionValueId !== optionValueId);
    });
  }

  function initSizeGuide(guide) {
    if (guide.dataset.sizeGuideInit === 'true') return;
    guide.dataset.sizeGuideInit = 'true';

    const position = Number(guide.dataset.optionPosition);

    guide.addEventListener('change', (event) => {
      const radio = event.target.closest('input[type="radio"][data-option-value-id]');
      if (!radio || !guide.contains(radio)) return;
      activateSizeGuide(guide, radio.dataset.optionValueId);
    });

    const modal = guide.closest('modal-dialog');
    if (modal) {
      new MutationObserver(() => {
        if (modal.hasAttribute('open')) {
          activateSizeGuide(guide, getPickerOptionValueId(position));
        }
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    }
  }

  function initAll() {
    document.querySelectorAll('.rb-size-guide-images').forEach(initSizeGuide);
  }

  let initScheduled = false;

  function scheduleInitAll() {
    if (initScheduled) return;
    initScheduled = true;
    requestAnimationFrame(() => {
      initScheduled = false;
      initAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  new MutationObserver(scheduleInitAll).observe(document.body, { childList: true, subtree: true });
})();
